// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2teXv","emails":"CreateEditClinics_emails__oNHzV","emailTagLabel":"CreateEditClinics_emailTagLabel__32eCq"};